import { type OnboardingGuidanceFlow, type OnboardingGuidanceStep, OnboardingFlowGroup } from '../../types';

export const stepRunAll: OnboardingGuidanceStep = {
  title: 'Try it out',
  description: 'Run these prompts and compare the results side-by-side.',
  selector: 'run-all-button',
};

export const stepCompareOutputs: OnboardingGuidanceStep = {
  title: 'Compare outputs',
  description: 'See how each model and prompt configuration performs side-by-side.',
  selector: 'playground-output-area',
};

export const stepModelSelect: OnboardingGuidanceStep = {
  title: 'Try a different model',
  description: 'Switch the model and re-run to compare how different models perform on the same prompt.',
  selector: 'model-select-button',
};

export const stepPressRun: OnboardingGuidanceStep = {
  title: 'Run it again',
  description: 'Hit Run to see how the new model compares.',
  selector: 'run-all-button',
};

export const stepSaveAs: OnboardingGuidanceStep = {
  title: 'Save your work',
  description: 'Save your prompt as a new config so you can wire up your app and safely release to production.',
  selector: 'save-as-button',
};

export const stepConfigsNav: OnboardingGuidanceStep = {
  title: 'Find your config',
  description:
    'Your saved config lives in the Configs list. From there you can manage targeting, variations, and releases.',
  selector: 'configs-nav',
};

export const playgroundRunAll: OnboardingGuidanceFlow = {
  name: 'playgroundRunAll',
  description: 'Run these prompts and compare the results side-by-side.',
  steps: [stepRunAll, stepCompareOutputs, stepModelSelect, stepPressRun, stepSaveAs, stepConfigsNav],
  group: OnboardingFlowGroup.AiConfigs,
};
